import type { ISerialize } from '@/objects/ISerialize';

export class GetDynamicReportParameterDataResponseLine implements ISerialize {
    public Display: string | null;

    public Parameter: string;

    public Val: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Display?: string | null; Parameter?: string | null; Val?: string | null }) {
        this.Display = values.Display ?? null;

        this.Parameter = values.Parameter ?? '';

        this.Val = values.Val ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Display": ${JSON.stringify(this.Display)}` +
            ',' +
            `"Parameter": ${JSON.stringify(this.Parameter)}` +
            ',' +
            `"Val": ${JSON.stringify(this.Val)}` +
            '}'
        );
    }

    /**
     * Creates an instance of GetDynamicReportParameterDataResponseLine from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Display?: string | null;
        Parameter?: string | null;
        Val?: string | null;
    }): GetDynamicReportParameterDataResponseLine {
        return new GetDynamicReportParameterDataResponseLine(values);
    }

    public static _FromServerJson(json: any): GetDynamicReportParameterDataResponseLine {
        return new GetDynamicReportParameterDataResponseLine({
            Display: json.Display ?? '',
            Parameter: json.Parameter ?? '',
            Val: json.Val ?? '',
        });
    }

    /**
     * Creates an instance of GetDynamicReportParameterDataResponseLine from another instance of GetDynamicReportParameterDataResponseLine.
     * @param other The GetDynamicReportParameterDataResponseLine you want to clone
     * @returns A cloned GetDynamicReportParameterDataResponseLine
     */
    public static FromOther(other: GetDynamicReportParameterDataResponseLine): GetDynamicReportParameterDataResponseLine {
        return GetDynamicReportParameterDataResponseLine._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return GetDynamicReportParameterDataResponseLine.FromOther(this);
    }

    static NAME_OF_CLASS = 'GetDynamicReportParameterDataResponseLine';
}
